import { render, staticRenderFns } from "./GameListScrollPage.vue?vue&type=template&id=c7f8a3a0&scoped=true"
import script from "./GameListScrollPage.vue?vue&type=script&lang=js"
export * from "./GameListScrollPage.vue?vue&type=script&lang=js"
import style0 from "./GameListScrollPage.vue?vue&type=style&index=0&id=c7f8a3a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f8a3a0",
  null
  
)

export default component.exports